import { render, staticRenderFns } from "./classification-rules-page.vue?vue&type=template&id=f09f3b7c&scoped=true"
import script from "./classification-rules-page.vue?vue&type=script&lang=js"
export * from "./classification-rules-page.vue?vue&type=script&lang=js"
import style0 from "./classification-rules-page.vue?vue&type=style&index=0&id=f09f3b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09f3b7c",
  null
  
)

export default component.exports